import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getOperatingSystem } from '@src/utils/os';
import { StyledInputSelectCountry } from './index.style';

const CustomSelect = ({
  isModileWeb,
  onSetShowDropdown,
  data,
  currentOption,
  onChange,
}) => {
  const currentOS = getOperatingSystem();
  const [selectedValue, setSelectedValue] = useState(currentOption);
  const [selectedIndex, setSelectedIndex] = useState(
    currentOption?.name !== ''
      ? data?.findIndex((item) => item?.name === currentOption?.name)
      : null,
  );
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState(data);
  const searchInputEl = useRef();
  const dropdownEl = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    setOptions(data);
  }, [data]);

  const changeSelectedHandler = (item, index) => {
    setSelectedValue(item);
    setSelectedIndex(index);
    onSetShowDropdown(false);
    onChange(item);
  };

  const searchChangeHandler = (e) => {
    setSearch(e.target.value);
    const filteredOptions = data.filter((opt) =>
      opt?.name?.toLowerCase().includes(e.target.value.trim().toLowerCase()),
    );
    setOptions(filteredOptions);
  };
  useEffect(() => {
    searchInputEl.current.focus();
    if (selectedValue) {
      const container = document?.querySelector('.dropdown__menu_items');
      const target = document?.querySelector(`.item-${selectedIndex}`);
      if (!container || !target) return;
      const targetRect = target.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const scrollToPosition =
        targetRect.top - containerRect.top + container.scrollTop;

      container.scrollTop = scrollToPosition;
    }
  }, [selectedValue]);
  return (
    <StyledInputSelectCountry isModileWeb={isModileWeb}>
      <div className="dropdown" ref={dropdownEl}>
        <input
          type="text"
          placeholder={t('newFindTitle')}
          className="dropdown__menu_search"
          value={search}
          onChange={searchChangeHandler}
          ref={searchInputEl}
        />
        <div className="dropdown__menu_items">
          {options?.map((item, index) => (
            <div
              role="button"
              tabIndex="0"
              className={
                ('dropdown__menu_item',
                selectedValue?.name === item?.name
                  ? `dropdown__menu_item item-${data.findIndex(
                      (it) => it?.name === item?.name,
                    )} selected`
                  : `dropdown__menu_item item-${data.findIndex(
                      (it) => it?.name === item?.name,
                    )}`)
              }
              key={isModileWeb ? item : `${item}-${index}`}
              onClick={() =>
                changeSelectedHandler(
                  item,
                  data.findIndex((it) => it?.name === item?.name),
                )
              }
            >
              <div className="info_contry">
                {currentOS !== 'Window' ? (
                  <div className="country_flag">{item?.emoji}</div>
                ) : (
                  <div className="country_code">{item?.code}</div>
                )}
                <div className="country_name">{item?.name}</div>
                <div className="country_dialcode">{item.dialCode}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </StyledInputSelectCountry>
  );
};

export default CustomSelect;
